import { Button, Form, message, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/slices/modalsSlice";
import usePaiementEmployee from "hooks/usePaiementEmployee";
import PaiementFormForModal from "./PaiementFormForModal";
import { useNavigate } from "react-router-dom";
const EditPaiementModal = () => {
  const navigate = useNavigate(); 
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { isModalOpen, modalType, modalProps } = useSelector(
        (state) => state.modals
    );
    const { getPaiementById, updatePaiement, paiement, isLoading, error, setError } = usePaiementEmployee();
    const [isSendForUpdate, setIsSendForUpdate] = useState(false);
    const [initialValues, setInitialValues] = useState(null);

    // Chargement initial des données
    useEffect(() => {
        if (modalProps?.paiementId && isModalOpen) {
            const loadPaiement = async () => {
                try {
                    const data = await getPaiementById(navigate,modalProps.paiementId);
                    setInitialValues({
                        fullName: `${data?.employee?.firstName || ''} ${data?.employee?.lastName || ''}`,
                        paymentDate: data?.paymentDate ? dayjs(data.paymentDate) : dayjs(),
                        amount: data.amount
                    });
                } catch (error) {
                    console.error("Erreur récupération paiement:", error);
                    notification.error({
                        message: t("common.error"),
                        description: t("paiements.crud.form.error.load")
                    });
                }
            };
            loadPaiement();
        }
    }, [modalProps?.paiementId, isModalOpen]);

    // Mise à jour du formulaire quand les valeurs initiales changent
    useEffect(() => {
        if (initialValues) {
            form.resetFields();
            form.setFieldsValue(initialValues);
        }
    }, [initialValues]);

    // Gestion des erreurs
    useEffect(() => {
        if (isSendForUpdate) {
            if (error) {
                message.error(`${t("paiements.crud.form.error.edit")}: ${error}`);
            } else {
                message.success(t("paiements.crud.form.edit.success"));
                onClose();
            }
            setIsSendForUpdate(false);
        }
    }, [isSendForUpdate, error]);

    const handleCancel = () => {
        form.resetFields();
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
    };

    const open = isModalOpen && modalType === "edit_paiement";

    const onSubmit = async (values) => {
        setError(null);
        setIsSendForUpdate(false);
        
        try {
            // Conversion des valeurs
            const formattedValues = {
                ...values,
               amount: Number(values.amount),
        paymentDate: values.paymentDate.format("YYYY-MM-DD")
            };

            await updatePaiement(navigate,formattedValues, modalProps?.paiementId);
            setIsSendForUpdate(true);
        } catch (error) {
            notification.error({
                message: t("paiements.crud.form.error.edit"),
                description: error.message,
                duration: 3
            });
        }
    };

    const onClose = () => {
        form.resetFields();
        setInitialValues(null);
        dispatch(closeModal());
    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            destroyOnClose
            footer={[
                <Button key="cancel" onClick={onClose} className="custom-btn-1">
                    {t("employees.crud.form.button.cancel")}
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    htmlType="submit"
                    form="paiement_form_modif"
                    loading={isLoading}
                    className="custom-btn-2"
                >
                    {t("employees.crud.form.button.save")}
                </Button>,
            ]}
            centered
            styles={{ content: { overflowY: "auto", maxHeight: "75vh", width: "100%" } }}
        >
            {initialValues && (
                <PaiementFormForModal 
                    form={form} 
                    handleFinish={onSubmit} 
                />
            )}
        </Modal>
    );
};

export default EditPaiementModal;